"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrapSpinner = exports.StyledFullHeight = exports.StyledLoader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = __importDefault(require("../colors"));
exports.StyledLoader = styled_components_1.default.div `
  color: official;
  display: inline-block;

  position: relative;

  left: calc(50% - 40px);
  top: calc(50% - 40px);
  width: 20px;
  height: 20px;

  & div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
  }
  & div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 32px;
    left: 40px;
    width: 2px;
    height: 4px;
    border-radius: 35%;
    background: ${({ variant, color, theme }) => {
    const variants = {
        secondary: theme.text.primary,
        contained: theme.white
    };
    return variants[variant] || color || theme.primary.main;
}};
  }
  & div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  & div:nth-child(2) {
    transform: rotate(45deg);
    animation-delay: -1s;
  }
  & div:nth-child(3) {
    transform: rotate(90deg);
    animation-delay: -0.9s;
  }
  & div:nth-child(4) {
    transform: rotate(135deg);
    animation-delay: -0.8s;
  }
  & div:nth-child(5) {
    transform: rotate(180deg);
    animation-delay: -0.7s;
  }
  & div:nth-child(6) {
    transform: rotate(225deg);
    animation-delay: -0.6s;
  }
  & div:nth-child(7) {
    transform: rotate(270deg);
    animation-delay: -0.5s;
  }
  & div:nth-child(8) {
    transform: rotate(315deg);
    animation-delay: -0.4s;
  }

  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
exports.StyledFullHeight = styled_components_1.default.span `
  display: flex;
  justify-content: center;
  margin-left: -5px;
`;
exports.StyledWrapSpinner = styled_components_1.default.span `
  display: flex;
  justify-content: center;
`;
const LoadSpinner = ({ variant, color }) => {
    return (react_1.default.createElement(exports.StyledWrapSpinner, null,
        react_1.default.createElement(exports.StyledFullHeight, null,
            react_1.default.createElement(exports.StyledLoader, { variant: variant, color: color },
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null)))));
};
const StyledMainButton = styled_components_1.default.button `
  width: ${({ size, variant }) => {
    const rightSize = {
        small: 80,
        medium: 142,
        large: 177
    };
    return variant === "text" ? "auto" : `${rightSize[size]}px`;
}};
  height: 33px;
  text-align: center;
  font-weight: 500;
  font-size: ${({ size }) => {
    const fontSize = {
        small: 12,
        medium: 14,
        large: 14
    };
    return `${fontSize[size]}px`;
}};
  cursor: ${({ isLoading, variant }) => {
    if (!isLoading || (isLoading && variant === "text"))
        return "pointer";
}};
  border-radius: ${({ variant }) => (variant === "text" ? 0 : "8px")};
  color: ${({ variant, color, theme }) => {
    const variants = {
        secondary: theme.text.primary,
        contained: theme.white
    };
    return variants[variant] || color || theme.primary.main;
}};
  background: ${({ variant, color, theme }) => {
    const variants = {
        secondary: theme.neutral.lighter,
        contained: color || theme.primary.main
    };
    return variants[variant] || theme.white;
}};
  border: 1.5px solid;
  border-color: ${({ variant, color, theme }) => {
    const variants = {
        raised: theme.white,
        text: "transparent",
        secondary: theme.neutral.lighter
    };
    return variants[variant] || color || theme.primary.main;
}};
  border-bottom-color: ${({ variant, color, theme }) => variant === "text" && (color || theme.primary.main)};
  box-shadow: ${({ variant }) => variant === "raised" ? "3px 3px 4px #99999940" : "none"};
  pointer-events: ${({ isLoading, variant }) => isLoading && variant != "text" && "none"};
  &:hover {
    background: ${({ variant, color, isLoading, theme }) => {
    const variants = {
        text: theme.white,
        secondary: colors_1.default.lightGrey
    };
    if (!isLoading)
        return variants[variant] || color || colors_1.default.orange;
}};
    border: ${({ isLoading }) => !isLoading && "1px solid"};
    border-color: ${({ variant, color, isLoading }) => {
    const variants = {
        text: "transparent",
        secondary: colors_1.default.lightGrey
    };
    if (!isLoading)
        return variants[variant] || color || colors_1.default.orange;
}};
    border-bottom-color: ${({ variant, color }) => variant === "text" && (color || colors_1.default.orange)};
    color: ${({ variant, color, isLoading }) => {
    const variants = {
        text: color || colors_1.default.orange,
        secondary: colors_1.default.darkGrey
    };
    if (!isLoading)
        return variants[variant] || colors_1.default.smokeGrey;
}};
    box-shadow: ${({ variant }) => variant === "raised" ? "3px 3px 4px #70707080" : "none"};
  }
  &:active {
    background: ${({ variant, color, isLoading, theme }) => {
    const variants = {
        text: theme.white,
        secondary: colors_1.default.grey
    };
    if (!isLoading)
        return variants[variant] || color || colors_1.default.fireOrange;
}};
    border: ${({ isLoading }) => !isLoading && "1px solid"};
    border-color: ${({ variant, color, isLoading }) => {
    const variants = {
        text: "transparent",
        secondary: colors_1.default.grey
    };
    if (!isLoading)
        return variants[variant] || color || colors_1.default.fireOrange;
}};
    border-bottom-color: ${({ variant, color }) => variant === "text" && (color || colors_1.default.fireOrange)};
    color: ${({ variant, color, theme }) => {
    const variants = {
        text: color || colors_1.default.fireOrange,
        secondary: colors_1.default.black
    };
    return variants[variant] || theme.white;
}};

    box-shadow: ${({ variant }) => variant === "raised" ? "1px 1px 4px #70707040" : "none"};
  }
  &:disabled {
    color: ${colors_1.default.dustGrey};
    background: ${({ variant, isLoading, theme }) => {
    const variants = {
        outlined: theme.white,
        contained: colors_1.default.grey,
        text: theme.white
    };
    if (!isLoading)
        return variants[variant] || colors_1.default.smokeGrey;
}};
    border: 1px solid;
    border-color: ${({ variant, isLoading }) => {
    const variants = {
        secondary: colors_1.default.smokeGrey,
        raised: colors_1.default.smokeGrey,
        text: `transparent transparent ${colors_1.default.dustGrey} transparent`
    };
    if (!isLoading)
        return variants[variant] || colors_1.default.grey;
}};
    box-shadow: ${({ variant }) => variant === "raised" ? "3px 3px 4px #99999940" : "none"};
  }
`;
const loadingMessage = (variant, color) => (react_1.default.createElement("div", { style: {
        display: "flex",
        justifyContent: "center",
        marginTop: "-1px",
        alignItems: "center"
    } },
    react_1.default.createElement(LoadSpinner, { variant: variant, color: color }),
    react_1.default.createElement("div", { style: { width: "7px", height: "7px" } }),
    " Loading"));
const RotaButton = (_a) => {
    var { onClick, children, variant = "contained", size = "medium", color = "orange", isLoading = false } = _a, props = __rest(_a, ["onClick", "children", "variant", "size", "color", "isLoading"]);
    return (react_1.default.createElement(StyledMainButton, Object.assign({ color: color, onClick: onClick, variant: variant, size: size, isLoading: isLoading }, props), isLoading && variant != "text"
        ? loadingMessage(variant, color)
        : children));
};
exports.default = RotaButton;
